module.exports = __webpack_public_path__ + "img/xlsx.e4531bb0.png";